
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 640"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M147 170.7L117.2 256h122.9v-96h-77.9c-6.8 0-12.9 4.3-15.1 10.7zm-98.4 87.2l37.9-108.3C97.8 117.5 128.1 96 162.1 96H360c25.2 0 48.9 11.9 64 32l96.2 128.3C587.1 260.5 640 316.1 640 384v16c0 35.3-28.7 64-64 64h-16.4c-4 44.9-41.7 80-87.6 80-45.9 0-83.6-35.1-87.6-80H239.7c-4 44.9-41.7 80-87.6 80-45.9 0-83.6-35.1-87.6-80h-.4c-35.3 0-64-28.7-64-64v-80c0-30.1 20.7-55.3 48.6-62.1zM440 256l-67.2-89.6c-3-4-7.8-6.4-12.8-6.4h-72v96h152zM152 496c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40 17.9 40 40 40zm360-40c0-22.1-17.9-40-40-40s-40 17.9-40 40 17.9 40 40 40 40-17.9 40-40z"}})])
          )
        }
      }
    